/** FA catalog — copy carried from the approved Access/Shell design files (FA authored in the handoff). */
export const fa: Record<string, string> = {
  'app.product': 'Zoyaar',
  'app.productFa': 'زویار',
  'app.clinicTag': 'CLINIC',
  'app.loading': 'در حال آماده‌سازی…',
  'app.configError': 'پیکربندی این نسخه بارگذاری نشد.',
  'app.retry': 'تلاش دوباره',

  'nav.today': 'امروز',
  'nav.calendar': 'تقویم',
  'nav.patients': 'مراجعان',
  'nav.payments': 'پرداخت‌ها',
  'nav.family': 'خانواده',
  'nav.clinicSetup': 'تنظیمات مرکز',
  'nav.railNote': 'همیشه با برچسب — هرگز فقط آیکون.',

  'signin.title': 'ورود',
  'signin.subEmail': 'با ایمیل و رمز عبوری که مرکز به شما داده است.',
  'signin.subMobile': 'کد ورود را به شمارهٔ موبایل شما پیامک می‌کنیم.',
  'signin.methodMobile': 'شماره موبایل',
  'signin.methodEmail': 'ایمیل',
  'signin.identifierLabel': 'ایمیل یا نام کاربری',
  'signin.identifierHelp': 'نشانی یا نام کاربری‌ای که مدیر مرکز برای شما ثبت کرده است.',
  'signin.passwordLabel': 'رمز عبور',
  'signin.passwordHelp': 'توسط مرکز به شما داده‌شده است. پس از ورود می‌توانید آن را تغییر دهید.',
  'signin.phoneLabel': 'شماره موبایل',
  'signin.phoneHelp': 'شماره‌ای که مدیر مرکز برای شما ثبت کرده است.',
  'signin.phoneInvalid':
    'یک شماره موبایل معتبر وارد کنید — مثلاً ۰۹۱۲۱۲۳۴۵۶۷، یا شکل کامل بین‌المللی با شروع +.',
  'signin.otpReqFailed':
    'درخواست کد انجام نشد — هیچ‌یک از اطلاعات واردشده از بین نرفت. شماره و اتصال را بررسی کنید و دوباره تلاش کنید.',
  'signin.cta': 'ورود',
  'signin.sendCode': 'ارسال کد',
  'signin.sending': 'در حال ورود…',
  'signin.otpNote': 'با ادامه، یک پیامک به این شماره ارسال می‌شود.',
  'signin.forgot': 'رمزم را فراموش کرده‌ام',
  'signin.underAuth':
    'حساب‌های کارکنان توسط مدیر مرکز ساخته می‌شود. اگر هنوز اطلاعات ورود خود را ندارید، از ایشان بخواهید — ثبت‌نام شخصی وجود ندارد.',
  'signin.required': 'لازم',
  'signin.optional': 'اختیاری',

  'signin.wrongCreds': 'ایمیل و رمز عبور با هم مطابقت ندارند',
  'signin.wrongCredsBody':
    'هر دو را بررسی کنید و دوباره تلاش کنید — رمزی که مرکز به شما داده به بزرگی و کوچکی حروف حساس است. اگر همچنان ناموفق بود، «رمز عبورم را فراموش کرده‌ام» در پایین، آن را به‌صورت ایمن بازنشانی می‌کند.',
  'signin.netTitle': 'دسترسی به سامانه مرکز برقرار نشد',
  'signin.netBody':
    'اطلاعات شما دقیقا همان‌طور که وارد کردید حفظ شده است. اتصال خود را بررسی کنید و دوباره تلاش کنید.',
  'signin.inactiveTitle': 'این حساب فعال نیست',
  'signin.inactiveBody':
    'دسترسی شما به این مرکز غیرفعال شده است. پرونده‌ها و یادداشت‌های شما بدون تغییر باقی‌مانده‌اند. لطفا با مدیر مرکز صحبت کنید — ایشان می‌تواند دسترسی را در زمانی دیگر، دوباره فعال نماید.',
  'signin.notReadyTitle': 'یک مرحله راه‌اندازی برای این حساب باقی‌مانده است',
  'signin.notReadyBody':
    'یک مرحله راه‌اندازی در سامانه مرکز برای این حساب باقی‌مانده است و تا زمانی که مدیر آن را تکمیل نکند، ورود کامل نمی‌شود. هیچ‌چیز از حساب شما از بین نرفته است.',
  'signin.wrongSurfaceTitle': 'این حساب از این‌جا وارد نمی‌شود',
  'signin.wrongSurfaceBody':
    'سامانه مرکز این حساب را می‌شناسد، اما حساب کارکنان مرکز نیست. اگر در این مرکز کار می‌کنید، از مدیر خود بخواهید نحوهٔ ساخت حساب‌تان را بررسی کند.',
  'signin.setNewTitle': 'تعیین رمز عبور خود',
  'signin.setNewSub':
    'رمزی که مرکز به شما داده بود، موقت و درست بود. اکنون رمز خودتان را انتخاب کنید — ورود در همین مرحله کامل می‌شود.',
  'signin.setNewCta': 'تعیین رمز عبور و ورود',
  'signin.setNewNote':
    'فقط این حساب تحت تأثیر قرار می‌گیرد. با بازگشت، تمام اطلاعات واردشده نگهداری می‌شود؛ رمز موقت تا زمان جایگزینی، برای این مرحله معتبر است.',
  'signin.setNewUnchanged': 'رمز جدید باید با رمز موقت متفاوت باشد.',
  'signin.setNewRejected': 'سامانه مرکز این رمز را نپذیرفت. قواعد بالا را بررسی کنید.',
  'signin.setNewNotRequired': 'این حساب دیگر نیازی به تغییر رمز ندارد — با رمز فعلی خود وارد شوید.',
  'signin.backToSignin': 'بازگشت به ورود',
  'signin.successTitle': 'خوش آمدید، {name}',
  'signin.successBody': 'شما وارد {clinic} شده‌اید.',
  'signin.successGoing': 'در حال انتقال به «امروز»…',

  'otp.codeTitle': 'گوشی خود را بررسی کنید',
  'otp.codeSubA': 'کدی را که به ',
  'otp.codeSubB': ' پیامک کردیم وارد کنید — شماره همان‌طور که وارد کردید باقی می‌ماند.',
  'otp.codeLabel': 'کد ۶ رقمی',
  'otp.codeHelp': 'از طریق پیامک ارسال شده است. در بیشتر گوشی‌ها به‌طور خودکار از پیام پر می‌شود.',
  'otp.invalid':
    'این کد صحیح نیست. جدیدترین پیامک را بررسی کنید — ممکن است پیامک قدیمی هنوز باز باشد یا کد منقضی شده باشد.',
  'otp.resend': 'ارسال کد تازه',
  'otp.resent': 'کد جدید در راه است',
  'otp.resentBody': 'از این پس فقط جدیدترین کد معتبر است. پیامک قدیمی را می‌توانید نادیده بگیرید.',
  'otp.throttledTitle': 'لطفاً پیش از درخواست کد جدید، کمی منتظر بمانید',
  'otp.throttledBody': 'سامانه مرکز از شما می‌خواهد کمی {wait} دیگر دوباره تلاش کنید.',
  'otp.resendWait': 'درخواست مجدد تا {wait}',
  'otp.cooldownTitle': 'کدی به‌تازگی ارسال شده',
  'otp.cooldownBody':
    'کمی به پیامک فرصت دهید تا برسد — به‌زودی می‌توانید کد جدید درخواست کنید. کدی که ارسال شده هنوز معتبر است.',
  'otp.windowTitle': 'کدهای درخواستی برای این شماره بیش از حد مجاز است',
  'otp.windowBody':
    'سامانه مرکز فعلا ارسال کد جدید به این شماره را متوقف کرده است. صبر کنید و دوباره تلاش نمایید — یا با ایمیل و رمز عبور وارد شوید.',
  'otp.lockedTitle': 'کدهای نادرست بیش از حد مجاز',
  'otp.lockedBody':
    'این تلاش برای ورود قفل‌شده است زیرا کد چندین بار نادرست وارد شده. تا پایان این مدت، کد جدید هم کمکی نمی‌کند.',
  'otp.throttledGeneric': 'سامانه مرکز از ما خواسته پیش از تلاش مجدد منتظر بمانیم.',
  'otp.serverWaitNote':
    'هر مدت انتظاری که این‌جا نمایش داده می‌شود از سامانه مرکز می‌آید — زویار هرگز چیزی از خود نمی‌سازد.',
  'otp.notSentTitle': 'کد ارسال نشد',
  'otp.notSentBody': 'لطفاً دوباره تلاش کنید. شماره‌ای که وارد کردید ذخیره‌شده است.',
  'otp.notSentNote': 'آخرین کد ارسال نشد — پس از پایان مدت انتظار می‌توانید دوباره درخواست کنید.',
  'otp.resendFailedTitle': 'امکان ارسال دوباره کد میسر نیست',
  'otp.resendFailedBody':
    'هیچ‌یک از اطلاعات واردشده از بین نرفت. اتصال را بررسی کنید و دوباره تلاش کنید — کدی که قبلا ارسال شده ممکن است هنوز معتبر باشد.',
  'otp.verify': 'بررسی کد',
  'devOtp.title': 'فقط برای توسعه — پیامک هنوز متصل نیست',
  'devOtp.body': 'سامانه مرکز این کد را همراه درخواست بازگرداند. آن را در زیر وارد کنید.',
  'devOtp.copy': 'کپی کد',
  'devOtp.copied': 'کپی شد',

  'forgot.title': 'تنظیم مجدد رمز عبور',
  'forgot.sub':
    'ایمیلی را که با آن وارد می‌شوید وارد کنید. کدی به شماره موبایل ثبت‌شده روی حساب پیامک می‌کنیم — رمز عبور شما هرگز به جایی ارسال نمی‌شود.',
  'forgot.emailHelp':
    'نشانی ایمیل حساب مرکز شما. پاسخ، چه حساب وجود داشته باشد و چه نداشته باشد، یکسان است.',
  'forgot.cta': 'کد را برایم پیامک کن',
  'forgot.codeSubA': 'کدی را که به شمارهٔ موبایل ثبت‌شده روی ',
  'forgot.codeSubB': ' پیامک کردیم وارد کنید. نشانی همان‌طور که وارد کردید باقی می‌ماند.',
  'forgot.expiredTitle': 'رمز عبور جدید تنظیم‌شده دیگر معتبر نیست',
  'forgot.expiredBody':
    'این کد استفاده شده، منقضی شده، یا از جای دیگری برای رمز جدید درخواست داده‌اید. یک‌بار دیگر از ایمیل خود شروع کنید — کد تازه‌ای پیامک می‌شود.',
  'forgot.underForgot':
    'اگر شماره موبایل روی حساب شما قدیمی است، مدیر مرکز می‌تواند آن را اصلاح کند — این صفحه چنین کاری را انجام نمی‌دهد.',
  'forgot.newPwTitle': 'رمز عبور جدید انتخاب کنید',
  'forgot.newPwSub': 'بلافاصله و در همه‌جا جایگزین رمز قبلی می‌شود.',
  'forgot.newPwLabel': 'رمز عبور جدید',
  'forgot.newPwHelp':
    'قواعد رمز عبور از سامانه مرکز می‌آید و هنگام تایپ در همین‌جا نمایش داده می‌شود.',
  'forgot.confirmLabel': 'تأیید رمز عبور جدید',
  'forgot.confirmHelp': 'آن را دوباره وارد کنید تا یک اشتباه تایپی شما را از حساب خارج نکند.',
  'forgot.mismatch':
    'این دو هنوز مطابقت ندارند. هیچ‌یک از اطلاعات واردشده پاک نشده است — فیلد دوم را بررسی کنید.',
  'forgot.matchOk': 'هر دو مطابقت دارند.',
  'forgot.setCta': 'ثبت رمز عبور جدید',
  'forgot.doneTitle': 'رمز عبور تغییر کرد',
  'forgot.doneBody':
    'برای امنیت، از همه دستگاه‌ها خارج شدید. حالا با رمز جدید وارد شوید — چیز دیگری در حساب شما عوض نشده است.',
  'forgot.doneCta': 'رفتن به ورود',
  'forgot.rulesTitle': 'الزامات رمز عبور',
  'forgot.rulesNote':
    'این‌ها قواعد خودِ سامانه مرکز است — همان‌هایی که هنگام ذخیره بررسی می‌شود. زویار قاعده‌ای از خود اضافه نمی‌کند.',
  'pw.ruleLength': 'بین {min, number} تا {max, number} کاراکتر',
  'pw.ruleDifferent.current': 'متفاوت با رمز عبور فعلی شما',
  'pw.ruleDifferent.temporary': 'متفاوت با رمز عبور موقت',
  'pw.ruleDifferent.previous': 'متفاوت با رمز عبور قبلی شما (هنگام ذخیره بررسی می‌شود)',
  'pw.rulePending': 'هنوز بررسی نشده',
  'pw.ruleMet': 'برآورده شده',
  'pw.ruleUnmet': 'برآورده نشده',

  'account.title': 'حساب من',
  'account.sub': 'هویت شما در این‌جا، و موارد معدودی که خودتان می‌توانید تغییر دهید.',
  'account.fullName': 'نام کامل',
  'account.noName': 'نام ثبت نشده',
  'account.role': 'نقش در مرکز',
  'account.roleNone': 'هنوز در پروفایل کارکنان شما تعیین نشده است.',
  'account.roleUnavailable':
    'در پروفایل کارکنان شما نگهداری می‌شود که نقش شما در این‌جا اجازه دسترسی به آن را ندارد.',
  'account.roleFailed': 'پروفایل کارکنان شما در حال حاضر خوانده نشد.',
  'account.roleHint': 'شغل حرفه‌ای شما در این مرکز، از پروفایل کارکنان شما.',
  'account.clinic': 'مرکز',
  'account.switchClinic': 'جابه‌جایی مرکز',
  'account.identity': 'واردشده به‌عنوان',
  'account.admin': 'مدیر مرکز',
  'account.language': 'زبان',
  'account.password': 'رمز عبور',
  'account.passwordValue': 'رمز عبوری که با آن وارد می‌شوید را تغییر دهید',
  'help.nav': 'فایل‌های راهنما',
  'help.title': 'فایل‌های راهنما',
  'help.sub': 'راهنماهای پنل مرکز — یکی را در مرورگر باز کنید یا دانلود نمایید.',
  'help.audience': 'برای: {who}',
  'help.version': 'نسخه {version} · {date}',
  'help.view': 'باز کردن',
  'help.download': 'دانلود',
  'account.signOut': 'خروج',

  'change.title': 'تغییر رمز عبور',
  'change.sub': 'پس از تغییر، در این‌جا وارد باقی می‌مانید.',
  'change.current': 'رمز عبور فعلی',
  'change.currentHelp': 'همان که اکنون با آن وارد می‌شوید — حتی اگر مرکز آن را ساخته باشد.',
  'change.ready':
    'هر سه فیلد الزامی است، رمز جدید باید قواعد را برآورده کند و دو رمز جدید باید مطابقت داشته باشند تا دکمه فعال گردد.',
  'change.cta': 'تغییر رمز عبور',
  'change.wrongCurrent':
    'این رمز عبور فعلی شما نیست. هیچ‌چیزی تغییر نکرد — آن را بررسی کنید و دوباره تلاش کنید.',
  'change.unchanged': 'رمز عبور جدید باید با رمز فعلی متفاوت باشد.',
  'change.doneBody':
    'این نشست وارد باقی می‌ماند. هر نشست دیگری روی دستگاه‌های دیگر بسته شد و به رمز جدید نیاز دارد.',
  'change.doneSignedOut':
    'رمز عبور تغییر کرد و همهٔ نشست‌ها، از جمله همین نشست، بسته شد. با رمز جدید دوباره وارد شوید.',
  'change.unavailable':
    'تغییر رمز عبور در حال حاضر در دسترس نیست — سامانه مرکز یک قطعی موقت گزارش کرده است. هیچ‌چیزی تغییر نکرد؛ کمی بعد دوباره تلاش کنید.',
  'change.notApplicable':
    'این حساب بدون رمز عبور وارد می‌شود، بنابراین در این‌جا چیزی برای تغییر وجود ندارد.',

  'chooser.title': 'در کدام مرکز کار می‌کنید؟',
  'chooser.sub':
    'شما به بیش از یک مرکز تعلق دارید. هر آنچه می‌بینید و انجام می‌دهید در مرکزی که انتخاب می‌کنید باقی می‌ماند — هر زمان می‌توانید از حساب خود تغییر دهید.',
  'chooser.suspended': 'دسترسی معلق شده است',
  'chooser.inactive': 'موقتا غیرفعال',
  'chooser.unnamed': 'مرکز (نام هنوز ثبت‌نشده است)',
  'chooser.memberSince': 'عضو از {date}',
  'chooser.open': 'کار در این مرکز',

  'today.title': 'امروز',
  'today.subTherapist':
    'نمای کلی روز شما — جلسات و کارهای ناتمام با نسخه‌های زمان‌بندی و ارائه خواهند آمد.',
  'today.cardBookingsTitle': 'جلسات امروز شما',
  'today.cardBookingsBody':
    'فهرست روز، پس از آماده‌شدن خوانش‌های زمان‌بندی سراسری مرکز (در حال ساخت)، در این‌جا نمایش داده می‌شود.',
  'today.cardWorkTitle': 'توجه لازم',
  'today.cardWorkUnpaid':
    '{n, plural, =0 {جلسه‌ای که برگزار شده و پرداختش ثبت‌نشده، وجود ندارد.} one {# جلسه برگزار شده که پرداختش ثبت‌نشده است.} other {# جلسه برگزار شده که پرداختشان ثبت‌نشده است.}}',
  'today.cardWorkOpen': 'باز کردن صف پرداخت‌نشده',

  'placeholder.title': 'هنوز چیزی در این‌جا نیست',
  'placeholder.body':
    '{area} بخشی از فاز توسعه بعدی است. هر آنچه در جای دیگر تنظیم کرده‌اید برای آن آماده باقی می‌ماند.',

  'entry.brandedSignIn': 'ورود به {clinic}.',
  'entry.notFoundTitle': 'مرکزی با این نشانی وجود ندارد',
  'entry.notFoundBody':
    'این پیوند به هیچ مرکزی تعلق ندارد. آن را با کسی که به شما داده بررسی کنید، یا برنامه را از نشانی اصلی آن باز کنید.',
  'entry.notFoundCta': 'باز کردن برنامه',
  'entry.deniedTitle': 'شما عضو این مرکز نیستید',
  'entry.deniedBody':
    'حساب شما به {clinic} دسترسی ندارد. از مدیر آن مرکز بخواهید شما را اضافه کند، یا در یکی از مرکزهای خود ادامه دهید.',
  'entry.deniedChoose': 'رفتن به مرکزهای من',
  'entry.copy': 'کپی نشانی',
  'entry.copied': 'کپی شد',
  'error.forbiddenTitle': 'این بخش متعلق به شخص دیگری است',
  'error.notFoundTitle': 'صفحه‌ای در این‌جا وجود ندارد',
  'error.notFoundBody':
    'این نشانی با هیچ‌چیز در برنامهٔ مرکز مطابقت ندارد — ممکن است اشتباه تایپ‌شده یا قدیمی باشد. هیچ‌چیزی از بین نرفته است.',
  'error.notFoundCta': 'رفتن به امروز',
  'error.forbiddenBody':
    'نقش شما شامل این بخش نمی‌شود. اگر به تغییری در این‌جا نیاز دارید، از مدیر مرکز بخواهید — ایشان می‌توانند در لحظه‌ای انجام دهند.',
  'error.authzDownTitle': 'دسترسی شما بررسی نشد',
  'error.authzDownBody':
    'سامانهٔ مرکز موقتاً در دسترس نیست، بنابراین هیچ‌چیزی باز نشد. کمی بعد دوباره تلاش کنید.',
  'error.inactiveTitle': 'این مرکز موقتا غیرفعال است',
  'error.inactiveBody':
    'پلتفرم زویار این مرکز را موقتا متوقف کرده است. هیچ‌چیزی در حساب شما تغییر نکرده — با فعال‌شدن مجدد مرکز، دسترسی شما دقیقا همان‌طور که بود بازمی‌گردد.',
  'error.inactiveChoose': 'انتخاب مرکز دیگر',
  'error.noAccessTitle': 'دسترسی به هیچ مرکزی وجود ندارد',
  'error.noAccessBody':
    'این حساب عضو هیچ مرکزی نیست. از مدیر مرکز خود بخواهید شما را اضافه کند، سپس دوباره تلاش کنید.',
  'ctx.lostTitle': 'زمینه مرکز شما تغییر کرد',
  'ctx.lostBody':
    'مرکزی که در آن کار می‌کردید دیگر برای این حساب در دسترس نیست — عضویت شما در آن پایان‌یافته یا معلق شده است. دیگر هیچ‌چیزی از آن نمایش داده نمی‌شود.',
  'ctx.lostInactive': 'مرکزی که در آن کار می‌کردید توسط پلتفرم موقتاً متوقف‌شده است.',
  'ctx.changedTitle': 'مرکز در تب دیگری تغییر کرد',
  'ctx.changedBody':
    'در تب دیگری به {clinic} تغییر دادید. این تب دیگر درخواستی ارسال نمی‌کند تا چیزی به مرکز اشتباه ارسال نشود. برای ادامه در آن‌جا این تب را بازخوانی کنید، یا خارج شوید.',
  'ctx.changedToNone':
    'در تب دیگری انتخاب مرکز را رها کردید. این تب دیگر درخواستی ارسال نمی‌کند. برای انتخاب مجدد بازخوانی کنید، یا خارج شوید.',
  'ctx.reload': 'بازخوانی این تب',
  'error.suspendedTitle': 'این حساب در این مرکز فعال نیست',
  'error.suspendedBody':
    'دسترسی شما در این‌جا غیرفعال شده است. پرونده‌ها و یادداشت‌های شما دست‌نخورده باقی‌مانده‌اند. مدیر مرکز می‌تواند دسترسی را دوباره فعال کند.',
  'common.loading': 'در حال بارگذاری…',
  'common.back': 'بازگشت',
  'common.cancel': 'لغو',
  'common.notNow': 'حالا نه',
  'common.unconfirmedWrite':
    'نتوانستیم تایید کنیم که این مورد ذخیره‌شده است. پیش از تلاش مجدد، صفحه را بازخوانی کنید.',
};
